export const Privacy = {
    PRIVATE: "Privacy.PRIVATE",
    PUBLIC: "Privacy.PUBLIC"
};
